export const data_extension = {
    raw: {
        geology: {
            segy: "segy",
            txt: "txt",
            bin: "bin"
        },
        seismic: {
            segy: "segy",
            txt: "txt",
            bin: "bin"
        },
        well: {
        },
        electricity: {
        },
        magnetism: {
        },
        gravity: {
        },
        remotesense: {
        },
        geochemical: {
        }
    },

    result: {
        geology: {
            segy: "segy",
            txt: "txt",
        },
        seismic: {
            segy: "segy",
            txt: "txt",

        },
        well: {
        },
        electricity: {
        },
        magnetism: {
        },
        gravity: {
        },
        remotesense: {
        },
        geochemical: {
        }
    },
    report:
    {
        geology: {
            doc: "doc",
            docx: "docx",
            pdf: "pdf",
        },
        seismic: {
            doc: "doc",
            docx: "docx",
            pdf: "pdf",

        },
        well: {
            doc: "doc",
            docx: "docx",
            pdf: "pdf",
        },
        electricity: {
        },
        magnetism: {
        },
        gravity: {
        },
        remotesense: {
        },
        geochemical: {
        }
    }
}